import React, {useState, useCallback,useRef } from "react";
import DropDownButton from "devextreme-react/drop-down-button";
import { useHistory } from 'react-router-dom';
import "devextreme/data/odata/store";
import { GridLayout } from "../../../../common/GridLayout";
import { Localization } from "../../../../common/Localization";
import {
  Column,
  DataGrid,
  GroupPanel,
  Grouping,
  FilterRow,
  FilterPanel,
  Sorting,
  Paging,
  Pager,
  LoadPanel,
  Export,
  ColumnHeaderFilter,
  ColumnChooser,
  ColumnChooserSearch,
  Selection,
  StateStoring,
  Toolbar,
  Item
} from "devextreme-react/data-grid";
import { Button } from "devextreme-react/button";

import _ from "lodash";
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
const buttonDropDownOptions = { width: 140 };
export default (props) => {
  const [currentLayout, setCurrentLayout]= useState("Default");
const dataGrid = useRef(null);
  const history = useHistory();
  const onSelectionChanged = ({ selectedRowsData }) => {
    const selectedData = selectedRowsData[0];
    if (selectedRowsData.length === 1) {
      props.parentCallback(selectedData);
    }
    else
      return;
  };
  const onItemClick = (e) => {
    console.log(e.itemData);
    switch (e.itemData.name) {
      case 'Sub Lots':
        history.push({
          pathname: '/wm/inventory-sublots',
          state: { detailItemRowid: e.itemData.itemRowid, detailLotRowid: e.itemData.lotRowid }
        });
        return;
      case 'Item':
        history.push({
          pathname: '/wm/inventory-items'
        });
        return;
      default:
        return;
    }
  }
  const allowedPageSizes = [5, 10, 20, "all"];

  const gridKey = "10b7d7af-404a-403c-9887-27dd7b9626e1";
  const loadState = useCallback(() => {return GridLayout.sendStorageRequest(gridKey, "GET", props.accessToken,null,currentLayout);}, [currentLayout]);
  const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", props.accessToken, state, currentLayout); }, [gridKey, currentLayout]);

  return (
    <div>
      <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
      ref={dataGrid}
        noDataText={props?.data?.length > 0 ? '' : 'No Data'}
        dataSource={props.data}
        showBorders={true}
        className="secondGrid-height"
        columnAutoWidth={true}
        allowColumnResizing={true}
        allowColumnReordering={true}
        onSelectionChanged={onSelectionChanged}
      >
        <Selection mode="single" />
        <ColumnChooser enabled={true} 
          title="Choose Column"
          width={290}
          height={290}
          sortOrder="asc"
        >
          <ColumnChooserSearch
            enabled={true}
            editorOptions={{ placeholder: 'Search column' }} />
        </ColumnChooser>
        <ColumnHeaderFilter />
        <Export enabled={true} allowExportSelectedData={true} text="Export" />
        <Sorting visible={true} mode="multiple" />
        <LoadPanel enabled={true} />
        <Paging defaultPageSize={10} />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={allowedPageSizes}
          showNavigationButtons={true}
        />
        <FilterRow visible={true} />
        <FilterPanel visible={true} />
        <GroupPanel visible={true} />
        <Grouping autoExpandAll={false} />
        <StateStoring
          enabled={true}
          type="custom"
          customLoad={loadState}
          storageKey={gridKey}
          customSave={saveState}
        />
        <Column
          dataField="rowid"
          caption=""
          cellRender={(rowid) => cellRender(rowid)}
        />
        <Column dataField="lotCode" caption={Localization.formatMessage('IMLOT.LOTCODE', 'Lot')}></Column>
        <Column dataField="lotDescription1" caption={Localization.formatMessage('IMLOT.DESCRIPTION_1', 'Description 1')} ></Column>
        <Column dataField="lotDescription2" caption={Localization.formatMessage('IMLOT.DESCRIPTION_2', 'Description 2')} ></Column>
        <Column dataField="lotStatus" caption={Localization.formatMessage('IMLOT.STATUS', 'Status')} ></Column>
        <Column dataField="dateIntroduce" dataType="date" caption={Localization.formatMessage('IMLOT.DATEINTRODUCED', 'Introduced DT')} ></Column>
        <Column dataField="dateAvailable" dataType="date" caption={Localization.formatMessage('IMLOT.DATEAVAILABLE', 'Available DT')} ></Column>
        <Column dataField="locationCode" caption={Localization.formatMessage('IMLOT.R_LOCATION', 'Default Location')} ></Column>
        <Column dataField="netAvailable" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.NETAVAILABLE', 'Net Avaialble')} ></Column>
        <Column dataField="lotUDFCode1" caption={Localization.formatMessage('IMLOT.USERDEFINEDCODE_1', 'Code 1')} visible={false}></Column>
        <Column dataField="lotUDFCode2" caption={Localization.formatMessage('IMLOT.USERDEFINEDCODE_2', 'Code 2')} visible={false}></Column>
        <Column dataField="lotUDFCode3" caption={Localization.formatMessage('IMLOT.USERDEFINEDCODE_3', 'Code 3')} visible={false}></Column>
        <Column dataField="lotUDFCode4" caption={Localization.formatMessage('IMLOT.USERDEFINEDCODE_4', 'Code 4')} visible={false}></Column>
        <Column dataField="lotUDFCode5" caption={Localization.formatMessage('IMLOT.USERDEFINEDCODE_5', 'Code 5')} visible={false}></Column>
        <Column dataField="lotUDFCode6" caption={Localization.formatMessage('IMLOT.USERDEFINEDCODE_6', 'Code 6')} visible={false}></Column>
        <Column dataField="lotUDFCode7" caption={Localization.formatMessage('IMLOT.USERDEFINEDCODE_7', 'Code 7')} visible={false}></Column>
        <Column dataField="lotUDFCode8" caption={Localization.formatMessage('IMLOT.USERDEFINEDCODE_8', 'Code 8')} visible={false}></Column>
        <Column dataField="lotUDFCode9" caption={Localization.formatMessage('IMLOT.USERDEFINEDCODE_9', 'Code 9')} visible={false}></Column>
        <Column dataField="lotUDFCode10" caption={Localization.formatMessage('IMLOT.USERDEFINEDCODE_10', 'Code 10')} visible={false}></Column>
        <Column dataField="lotUDFRef1" caption={Localization.formatMessage('IMLOT.USERDEFINEDREFERENCE_1', 'Reference 1')} visible={false}></Column>
        <Column dataField="lotUDFRef2" caption={Localization.formatMessage('IMLOT.USERDEFINEDREFERENCE_2', 'Reference 2')} visible={false}></Column>
        <Column dataField="lotUDFRef3" caption={Localization.formatMessage('IMLOT.USERDEFINEDREFERENCE_3', 'Reference 3')} visible={false}></Column>
        <Column dataField="lotUDFRef4" caption={Localization.formatMessage('IMLOT.USERDEFINEDREFERENCE_4', 'Reference 4')} visible={false}></Column>
        <Column dataField="lotUDFRef5" caption={Localization.formatMessage('IMLOT.USERDEFINEDREFERENCE_5', 'Reference 5')} visible={false}></Column>
        <Column dataField="lotUDFRef6" caption={Localization.formatMessage('IMLOT.USERDEFINEDREFERENCE_6', 'Reference 6')} visible={false}></Column>
        <Column dataField="lotUDFRef7" caption={Localization.formatMessage('IMLOT.USERDEFINEDREFERENCE_7', 'Reference 7')} visible={false}></Column>
        <Column dataField="lotUDFRef8" caption={Localization.formatMessage('IMLOT.USERDEFINEDREFERENCE_8', 'Reference 8')} visible={false}></Column>
        <Column dataField="lotUDFRef9" caption={Localization.formatMessage('IMLOT.USERDEFINEDREFERENCE_9', 'Reference 9')} visible={false}></Column>
        <Column dataField="lotUDFRef10" caption={Localization.formatMessage('IMLOT.USERDEFINEDREFERENCE_10', 'Reference 10')} visible={false}></Column>
        <Column dataField="lotUDFDate1" dataType="date" caption={Localization.formatMessage('IMLOT.USERDEFINEDDATE_1', 'Date 1')} visible={false}></Column>
        <Column dataField="lotUDFDate2" dataType="date" caption={Localization.formatMessage('IMLOT.USERDEFINEDDATE_2', 'Date 2')} visible={false}></Column>
        <Column dataField="lotUDFDate3" dataType="date" caption={Localization.formatMessage('IMLOT.USERDEFINEDDATE_3', 'Date 3')} visible={false}></Column>
        <Column dataField="lotUDFDate4" dataType="date" caption={Localization.formatMessage('IMLOT.USERDEFINEDDATE_4', 'Date 4')}visible={false}></Column>
        <Column dataField="lotUDFDate5" dataType="date" caption={Localization.formatMessage('IMLOT.USERDEFINEDDATE_5', 'Date 5')} visible={false}></Column>
        <Column dataField="lotUDFDate6" dataType="date" caption={Localization.formatMessage('IMLOT.USERDEFINEDDATE_6', 'Date 6')} visible={false}></Column>
        <Column dataField="lotUDFDate7" dataType="date" caption={Localization.formatMessage('IMLOT.USERDEFINEDDATE_7', 'Date 7')} visible={false}></Column>
        <Column dataField="lotUDFDate8" dataType="date" caption={Localization.formatMessage('IMLOT.USERDEFINEDDATE_8', 'Date 8')} visible={false}></Column>
        <Column dataField="lotUDFDate9" dataType="date" caption={Localization.formatMessage('IMLOT.USERDEFINEDDATE_9', 'Date 8')} visible={false}></Column>
        <Column dataField="lotUDFDate10" dataType="date" caption={Localization.formatMessage('IMLOT.USERDEFINEDDATE_10', 'Date 10')} visible={false}></Column>
        <Column dataField="lotUDFQty1" caption={Localization.formatMessage('IMLOT.USERDEFINEDQUANTITY_1', 'Quantity 1')} visible={false}></Column>
        <Column dataField="lotUDFQty2" caption={Localization.formatMessage('IMLOT.USERDEFINEDQUANTITY_2', 'Quantity 2')} visible={false}></Column>
        <Column dataField="lotUDFQty3" caption={Localization.formatMessage('IMLOT.USERDEFINEDQUANTITY_3', 'Quantity 3')} visible={false}></Column>
        <Column dataField="lotUDFQty4" caption={Localization.formatMessage('IMLOT.USERDEFINEDQUANTITY_4', 'Quantity 4')} visible={false}></Column>
        <Column dataField="lotUDFQty5" caption={Localization.formatMessage('IMLOT.USERDEFINEDQUANTITY_5', 'Quantity 5')} visible={false}></Column>
        <Column dataField="lotUDFQty6" caption={Localization.formatMessage('IMLOT.USERDEFINEDQUANTITY_6', 'Quantity 6')} visible={false}></Column>
        <Column dataField="lotUDFQty7" caption={Localization.formatMessage('IMLOT.USERDEFINEDQUANTITY_7', 'Quantity 7')} visible={false}></Column>
        <Column dataField="lotUDFQty8" caption={Localization.formatMessage('IMLOT.USERDEFINEDQUANTITY_8', 'Quantity 8')} visible={false}></Column>
        <Column dataField="lotUDFQty9" caption={Localization.formatMessage('IMLOT.USERDEFINEDQUANTITY_9', 'Quantity 9')} visible={false}></Column>
        <Column dataField="lotUDFQty10" caption={Localization.formatMessage('IMLOT.USERDEFINEDQUANTITY_10', 'Quantity 10')} visible={false}></Column>
        <Column dataField="lotAvailable" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.AVAILABLE', 'Available')} visible={false}></Column>
        <Column dataField="lotOnHand" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.ON_HAND', 'On Hand')} visible={false}></Column>
        <Column dataField="lotInReceiving" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.IN_RECEIVING', 'In Receiving')} visible={false}></Column>
        <Column dataField="lotOutShipped" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.OUT_SHIPPED', 'Out Shipped')} visible={false}></Column>
        <Column dataField="lotOutUnavailable" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.OUT_UNAVAILABLE', 'Out Unavailable')}  visible={false}></Column>
        <Column dataField="lotInOrdered" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.IN_ORDERED', 'In Ordered')} visible={false}></Column>
        <Column dataField="lotOutOrdered" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.OUT_ORDERED', 'Out Ordered')} visible={false}></Column>
        <Column dataField="lotInFuture" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.IN_FUTURE', 'In Future')} visible={false}></Column>
        <Column dataField="lotOutFuture" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.OUT_FUTURE', 'Out Future')} visible={false}></Column>
        <Column dataField="lotNetWeightQty" caption={Localization.formatMessage('IMLOT.NETWEIGHTQUANTITY', 'Unit Net Wt')} visible={false}></Column>
        <Column dataField="lotGrossWeightQty" caption={Localization.formatMessage('IMLOT.GROSSWEIGHTQUANTITY', 'Unit Gross Wt')} visible={false}></Column>
        <Column dataField="dateExpiration" dataType="date" caption={Localization.formatMessage('IMLOT.DATEEXPIRATION', 'Expiration Dt')} visible={false}></Column>
        <Column dataField="unitsPerPackageQuantity" caption={Localization.formatMessage('IMLOT.UNITSPERPACKAGEQUANTITY', 'Units / Package Qty')} visible={false}></Column>
        <Column dataField="lotFirstReceipt" caption={Localization.formatMessage('IMLOT.INTRANSACTIONNNUMBER', 'First Receipt')} visible={false}></Column>      
        <Column dataField="storageBillingStartDate" dataType="date" caption={Localization.formatMessage('IMLOT.STORAGEBILLINGSTARTDATE', 'Storage Billing Start Date')} visible={false}></Column>
        <Column dataField="storageBillingEndDate" dataType="date" caption={Localization.formatMessage('IMLOT.STORAGEBILLINGENDDATE', 'Storage Billing End Date')} visible={false}></Column>
        <Column dataField="storageBilledDateLast" dataType="date" caption={Localization.formatMessage('IMLOT.STORAGEBILLEDDATE_LAST',  'Storage Billing Last Date ')} visible={false}></Column>
        <Column dataField="storageBilledDateNext" dataType="date" caption={Localization.formatMessage('IMLOT.STORAGEBILLEDDATE_NEXT', 'Storage Billing Next Date')} visible={false}></Column>
        <Column dataField="prevStorageBilledDateLast" dataType="date" caption={Localization.formatMessage('IMLOT.PREVSTORAGEBILLEDDATE_LAST', 'Previous Storage Billing Last Date', true)} visible={false}></Column>
        <Column dataField="prevStoragebBilledDateNext" dataType="date" caption={Localization.formatMessage('IMLOT.PREVSTORAGEBILLEDDATE_NEXT', 'Previous Storage Billing Next Date', true)} visible={false}></Column>
        <Toolbar>

          <Item location="before">
            <Button
              disabled={props.locbtnDisable}
              onClick={props.openLocations}
              text="Location"
              type="default"
            >

            </Button>
          </Item>
          <Item location="before">
            <Button
              className="gridTopButton"
              disabled={props.SerialNumberBtnDisable}
              onClick={props.openSerialnumberPopUp}
              text="Serial Sumbers"
              type="default"
            >

            </Button>
          </Item>
          <Item location="before">
            <Button
              className="gridTopButton"
              disabled={props.statusbtnDisable}
              onClick={props.openStatus}
              text="Status"
              type="default"
            >

            </Button>
          </Item>
      <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                 </Item>
                 <Item name="exportButton"  />
                 <Item name="columnChooserButton"/>  
      </Toolbar>
      </DataGrid>
    </div>
  );
  function cellRender(rowid) {
    return (
      <DropDownButton
        className="dropdownWithoutText"
        dropDownOptions={buttonDropDownOptions}
        items={[
          { name: "Item", tab: 1 },
          { name: "Sub Lots", tab: 2, lotRowid: rowid.data.lotRowid, itemRowid: rowid.data.itemRowid }
        ]}
        displayExpr="name"
        keyExpr="rowId"
        onItemClick={onItemClick}
      />
    );
  }
};
